module.exports = __webpack_public_path__ + "static/media/09.e8dfaffb.mp3";